import React, { useEffect, useState } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import commonStyle from "../../../style/commonStyle.module.css";
import useDocumentTitle from "../../../useDocumentTitle";
import ScreenTitle from "../../../components/ScreenTitle";
import { NavLink } from "react-router-dom";
import { ErrorMessage, Loader } from "../../../components/smallComponents";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../../components/Pagination";
import { EditLinkButton, LinkButton } from "../../../components/buttons";
import { questionList } from "../../../api/webContentRequets";

export default function FaqList() {
  useDocumentTitle("FAQ List");
  const dispatch = useDispatch();

  const { userInfo } = useSelector((state) => state.userLogin);
  const config = {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${userInfo.data.token}`,
    },
  };

  const pageSize = 20;
  const [pageNum, setPageNum] = useState(0);
  const [reqStatus, setReqStatus] = useState({
    loading: false,
    success: false,
    error: "",
  });

  const [questions, setQuestions] = useState();

  const onPageChangeRequest = (page) => {
    setPageNum(page.selected);
  };

  useEffect(() => {
    const getQuestionList = async () => {
      try {
        setReqStatus((preState) => ({
          ...preState,
          loading: true,
        }));

        const responseData = await questionList(
          pageNum,
          pageSize,
          config,
          dispatch
        );
        if (responseData.data.success) {
          setReqStatus((preState) => ({
            ...preState,
            loading: false,
            success: true,
          }));
          setQuestions(responseData.data.data);
        } else {
          throw responseData.data.message;
        }
      } catch (error) {
        setReqStatus((preState) => ({
          ...preState,
          loading: false,
          error: error,
        }));
      }
    };

    getQuestionList();
  }, [dispatch, pageNum]);

  return (
    <div className={commonStyle.pageContainer}>
      <div className="w-full p-8">
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink underline="hover" color="inherit" to="/">
            Home
          </NavLink>
          <NavLink underline="hover" color="inherit" to="/web-content/faq">
            FAQ
          </NavLink>
        </Breadcrumbs>
        <ScreenTitle title="FAQ" />

        {reqStatus.loading ? (
          <Loader mess="Requesting questions..." />
        ) : reqStatus.success ? (
          <div className={commonStyle.longDataTable}>
            <div className="w-full flex justify-end">
              <LinkButton
                path="/web-content/faq/new"
                name="Add New Question"
                width="fit"
              />
            </div>
            <table className={commonStyle.pageTable}>
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Question</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {questions.questions.length > 0 ? (
                  questions.questions.map((item, index) => (
                    <tr key={index}>
                      <td>{item.type}</td>
                      <td>{item.question}</td>

                      <td>
                        <EditLinkButton
                          path={`/web-content/faq/edit/${item.id}`}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>
                      There are no question available. Please add a new one now.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {questions.questions.length > 0 ? (
              <Pagination
                totalPageNum={questions.totalPages}
                forcePage={pageNum}
                onPageChange={onPageChangeRequest}
              />
            ) : (
              <></>
            )}
          </div>
        ) : reqStatus.error ? (
          <ErrorMessage mess={reqStatus.error} />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
